<template>
  <div class="flex justify-center mt-10">
    <div class="flex flex-col gap-6 text-center px-12 max-w-2xl">
      <div class="flex-col gap-6">
        <img
          :src="image ?? '/images/empty/no-results.svg'"
          class="mx-auto w-36"
        />
        <div>
          <h2 class="text-xl font-semibold">
            {{ title ?? t("components.empty_states.list_view.title") }}
          </h2>
          <p class="text-gray-500 text-sm">
            {{
              description ?? t("components.empty_states.list_view.description")
            }}
          </p>
        </div>
      </div>
      <primary-button
        class="self-center"
        v-if="typeof hideButton === 'function' ? !hideButton() : !hideButton"
        :label="
          buttonLabel ?? t('components.empty_states.list_view.clear_filters')
        "
        @click="buttonAction"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton";

const { t } = useI18n();

const emit = defineEmits(["click"]);

defineProps({
  title: String,
  description: String,
  image: String,
  hideButton: [Boolean, Function],
  buttonLabel: String,
});

const buttonAction = () => emit("click");
</script>
